import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
  color?: string;
}

function Folder({ color }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 512 512"
      width="300"
      height="300"
    >
      <g transform="matrix(1,0,0,1,0,0)">
        <path
          d="M20.102,435.52C21.924,467.019,48.044,492,80,492h60c-33.137,0-60-26.863-60-60c0,0,0-185.222,0-271.604c-22.823,19.901-38.941,33.956-38.941,33.956C28.171,205.357,20,221.724,20,240v192C20,433.181,20.034,434.355,20.102,435.52z"
          fill="none"
          stroke="none"
          strokeOpacity="1"
        />
        <g>
          <line
            x1="199.431"
            y1="256.569"
            x2="312.569"
            y2="143.431"
            fill="none"
            stroke="#155a9e"
            strokeWidth="25"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <line
            x1="199.431"
            y1="143.431"
            x2="199.431"
            y2="143.431"
            fill="none"
            stroke="#155a9e"
            strokeWidth="25"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <line
            x1="312.569"
            y1="256.569"
            x2="312.569"
            y2="256.569"
            fill="none"
            stroke="#155a9e"
            strokeWidth="25"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M281.961,29.568l188.98,164.784C483.829,205.357,492,221.724,492,240v192c0,33.137-26.863,60-60,60H80c-33.137,0-60-26.863-60-60V240c0-18.276,8.171-34.643,21.059-45.648l188.98-164.784C237.026,23.602,246.092,20,256,20S274.974,23.602,281.961,29.568z"
          fill="none"
          stroke={color ?  color : "#424242"}
          strokeWidth="25"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <path
          d="M96,265.714l136.75,97.679c13.908,9.934,32.591,9.934,46.499,0L416,265.714"
          fill="none"
         stroke={color ?  color : "#424242"}
          strokeWidth="25"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <line
          x1="452"
          y1="60"
          x2="492"
          y2="20"
          fill="none"
         stroke={color ?  color : "#424242"}
          strokeWidth="25"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <line
          x1="20"
          y1="20"
          x2="60"
          y2="60"
          fill="none"
         stroke={color ?  color : "#424242"}
          strokeWidth="25"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
}

export default Folder;
